export default "__VITE_ASSET__BdaR1mgy__"